import { ClockIcon } from "@heroicons/react/24/outline";
import useCountdown from "../../hooks/useCountdown";

export default function CountdownTimer({ remainingSeconds, onExpire }) {
  const { formattedTime, remainingSeconds: seconds } = useCountdown(
    remainingSeconds,
    onExpire
  );

  const colorClass =
    seconds <= 60
      ? "bg-red-50 text-red-700 ring-red-300 animate-pulse"
      : seconds <= 300
        ? "bg-amber-50 text-amber-700 ring-amber-300"
        : "bg-slate-50 text-slate-900 ring-slate-200";

  return (
    <div
      className={`inline-flex h-10 items-center gap-2 rounded-lg px-3 ring-1 ring-inset transition-colors duration-200 ${colorClass}`}
    >
      <ClockIcon className="h-5 w-5 opacity-70" aria-hidden="true" />
      <span className="font-mono text-lg font-semibold tabular-nums tracking-tight">{formattedTime}</span>
    </div>
  );
}
